import { render, staticRenderFns } from "./side-menu-layout.vue?vue&type=template&id=65fae943&lang=pug&"
import script from "./side-menu-layout.vue?vue&type=script&lang=ts&"
export * from "./side-menu-layout.vue?vue&type=script&lang=ts&"
import style0 from "./side-menu-layout.vue?vue&type=style&index=0&id=65fae943&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports